module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-netaly-reshef-187083-small-ce1cc0abd0b9829692cf879474cd4b88.jpg";